import React from "react";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { serialize } from "next-mdx-remote/serialize";
import { MDXRemote } from "next-mdx-remote";

import Container from "../components/Common/Container";
import letterIllustration from "../public/static/images/demo/illustration.png";
import MetaTags from "../components/Common/MetaTags/MetaTags.js";
import getTranslationByPath from "../services/getTranslationByPath.mjs";
import { useTranslation } from "next-i18next";
import CloudinaryImage from "../components/Common/CloudinaryImage";
import PipeDriveForm from "../components/Common/PipedriveForm/PipedriveForm";

export default function Demo({  content }) {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up("md"), {
    defaultMatches: true,
  });
  const { t } = useTranslation("demo");

  return (
    <Container>
      <MetaTags scope="demo" />
      <Grid container spacing={isMd ? 8 : 4}>
        <Grid item xs={12} md={6}>
          <Typography
            variant="h2"
            component={"h1"}
            mb={2}
            sx={{
              fontWeight: 700,
            }}
          >
            {t("title")}
          </Typography>
          <Typography variant="p" color={"textSecondary"} component="div">
            <MDXRemote {...content} />
          </Typography>
          <Box sx={{ width: "100%", marginTop: 3, textAlign: "center" }}>
            <CloudinaryImage
              src={letterIllustration}
              alt="Illustration letter"
              width={460}
              height={274}
              priority
            />
          </Box>
        </Grid>
        <Grid item container xs={12} md={6} alignItems={"center"}>
          <Box
            padding={{ xs: 3, sm: 6 }}
            width={"100%"}
            component={Card}
            borderRadius={2}
            boxShadow={4}
            marginBottom={4}
            className="pipedriveWebForms"
          >
           <PipeDriveForm formId={t("pipedrive_form_id")}/>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
}

export async function getStaticProps({ locale }) {
  const { content } = getTranslationByPath("demo", locale);

  return {
    props: {
      ...(await serverSideTranslations(locale, [
        "common",
        "demo",
      ])),
      content: await serialize(content.content),
    },
  };
}
